import { GzTimePickerWebComponent } from './component/GzTimePickerWebComponent';
import { WEB_COMPONENT_GZ_TIME_PICKER } from '../../webcomponents.constants';

export { GzTimePickerWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_TIME_PICKER, GzTimePickerWebComponent);
